var map = {
	"./decidim/avatar-multiuser.png": 60632,
	"./decidim/brands/facebook.svg": 25958,
	"./decidim/brands/google.svg": 17671,
	"./decidim/brands/twitter-x.svg": 44652,
	"./decidim/cc-badge.png": 24082,
	"./decidim/decidim-logo.svg": 44378,
	"./decidim/default-avatar.svg": 2438,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 34394,
	"./decidim/icons.svg": 86473,
	"./decidim/pattern.png": 13958,
	"./decidim/placeholder-card-g.svg": 94827,
	"./decidim/placeholder-card-l.svg": 97440,
	"./decidim/placeholder.jpg": 28103,
	"./decidim/remixicon.symbol.svg": 97503,
	"./decidim/vendor/social-share-button/douban.svg": 49166,
	"./decidim/vendor/social-share-button/email.svg": 4011,
	"./decidim/vendor/social-share-button/facebook.svg": 53869,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 21591,
	"./decidim/vendor/social-share-button/hacker_news.svg": 54767,
	"./decidim/vendor/social-share-button/linkedin.svg": 54675,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 39516,
	"./decidim/vendor/social-share-button/pinterest.svg": 34365,
	"./decidim/vendor/social-share-button/reddit.svg": 73389,
	"./decidim/vendor/social-share-button/telegram.svg": 35988,
	"./decidim/vendor/social-share-button/tumblr.svg": 7035,
	"./decidim/vendor/social-share-button/twitter.svg": 42954,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5076,
	"./decidim/vendor/social-share-button/wechat.svg": 44847,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7503,
	"./decidim/vendor/social-share-button/x.svg": 37579,
	"./decidim/vendor/social-share-button/xing.svg": 68285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89991;